import createFetchClient from 'openapi-fetch';
import { BaseUrl } from '~/types/baseUrl';
import createClient from 'openapi-react-query';
import { paths } from './openapi';

const baseUrl: BaseUrl = {
  production: 'https://platform.versori.com/api/v2',
  staging: 'https://platform-staging.versori.com/api/v2',
  development: 'http://localhost:8901',
};
export const versoriBaseUrl = import.meta.env.DEV
  ? baseUrl.development
  : import.meta.env.VITE_STAGING
    ? baseUrl.staging
    : baseUrl.production;

export const versoriApiFetchClient = createFetchClient<paths>({
  baseUrl: versoriBaseUrl,
  credentials: 'include',
  mode: 'cors',
  headers: {
    ...(import.meta.env.VITE_API_JWT && {
      'X-Versori-Internal-Token': import.meta.env.VITE_API_JWT,
    }),
  },
});

export const versoriApi = createClient(versoriApiFetchClient);
